<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
      v-if="branchUUID !== undefined"
    ></div>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('branchPlace.cloned') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('branchPlace.notCloned') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import branchPlaceApi from '@/services/branches/branch-place.api'
import { statusFormatter } from '@/utils/tableFormatter'
import Toastify from 'toastify-js'

export default defineComponent({
  props: {
    branchUUID: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'side-menu-branch-places-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    showEdit(e, cell) {
      this.$router.push({
        name: 'side-menu-branch-places-edit',
        params: { uuid: cell.getData().uuid }
      })
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    },
    editFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.edit') +
        '</button></div>'
      )
    },
    cloneFormatter() {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.clone') +
        '</button></div>'
      )
    },
    async cloneBranchPlace(e, cell) {
      const uuid = cell.getData().uuid

      try {
        await branchPlaceApi.cloneBranchPlace(cell.getData().uuid)
        this.tabulator.replaceData()
        Toastify({
          node: cash('#success-notification-content').clone().removeClass('hidden')[0],
          duration: 5000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
      } catch (error) {
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        console.error('Error sorting order:', error)
      }
    },
    async handleSortOrderClick(e, cell) {
      const uuid = cell.getData().uuid
      const direction = e.target.classList.contains('sort-up-action') ? 'UP' : 'DOWN'

      try {
        await branchPlaceApi.sortOrder(uuid, { direction: direction })
        this.tabulator.replaceData()
      } catch (error) {
        console.error('Error sorting order:', error)
      }
    },
    sortOrderFormatter(cell) {
      return `
        <div class="flex items-center justify-center space-x-2">
          <button class="btn btn-sm btn-primary-soft sort-up-action" data-uuid="${
            cell.getData().uuid
          }">
            &uarr;
          </button>
          <button class="btn btn-sm btn-primary-soft sort-down-action" data-uuid="${
            cell.getData().uuid
          }">
            &darr;
          </button>
        </div>
      `
    },
    getTableData(url, config, params) {
      console.log(url)
      console.log(params)
      console.log(config)
      console.log(this.branchUUID)
      return branchPlaceApi.getList(
        this.branchUUID,
        params.page,
        params.size,
        params.sort
      )
    }
  },
  mounted() {
    const translate = this.$t
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: this.getTableData,
      ajaxResponse: function (url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.internalName'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().internalName
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.sortOrder'),
          minWidth: 50,
          responsive: 0,
          field: 'order',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().order ?? ''
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.capacity'),
          minWidth: 100,
          headerSort: false,
          field: 'duration',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().capacity === null ? '&#8734;' : cell.getData().capacity
                }</div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'status',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: (cell) => statusFormatter(cell, translate, '')
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionEdit',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionClone',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.cloneFormatter,
          cellClick: this.cloneBranchPlace
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionSortOrder',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.sortOrderFormatter,
          cellClick: this.handleSortOrderClick // Use the new handler
        }
      ]
    })
  },
  setup(props) {}
})
</script>
